import { useState } from "react";
import useContasRecorrentesNaoLancadas from "core/features/conta-recorrente/hooks/useContasRecorrentesNaoLancadas";
import { OperacaoEnum } from "resources/enums/conta";
import Card2Horizontal from "components/Cards/Card2Horizontal";
import { AiOutlineRedo, AiOutlineInfoCircle } from "react-icons/ai";
import colors from "core/resources/theme/colors";
import ModalTableContaRecorrente from "ui/components/Features/Financeiro/ContaRecorrente/components/ModalTableContaRecorrente";
import { Flex } from "@chakra-ui/react";

function ContasRecorrentesNaoLancadas({
  operacao,
  mes,
}: {
  operacao?: OperacaoEnum;
  mes?: string;
}) {
  const [modalOpen, setModalOpen] = useState(false);

  const { data, isLoading, isFetching, refetch } =
    useContasRecorrentesNaoLancadas(operacao, mes);

  return (
    <>
      <Card2Horizontal
        icon={<AiOutlineRedo fontSize={24} />}
        color={colors.gray}
        bg={colors.blueishGray100}
        description={"Recorrentes a lançar"}
        title={`${mes ? data?.quantidade ?? 0 : "--"}`}
        loading={isLoading || isFetching}
        onClick={() => {
          if (mes && data?.ids.length) {
            setModalOpen(true);
          }
        }}
        right={
          !mes ? (
            <Flex
              title="Só é possível visualizar essa estatística ao filtrar um único mês"
              position="absolute"
            >
              <AiOutlineInfoCircle fontSize={"24px"} color={colors.blue500} />
            </Flex>
          ) : null
        }
      />

      {!!operacao && modalOpen ? (
        <ModalTableContaRecorrente
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          ids={data?.ids}
          operacao={operacao}
          mes={mes}
          refetch={refetch}
        />
      ) : null}
    </>
  );
}

export default ContasRecorrentesNaoLancadas;
